module.exports = __webpack_public_path__ + "img/branco.6486229a.jpg";